module.exports = __webpack_public_path__ + "img/20200608004508.fc64b4d5.png";